import React from 'react'
import AdvertisementCard from './Card';
// import avatar1 from "assets/img/avatars/avatar1.png";
// import avatar2 from "assets/img/avatars/avatar2.png";
// import avatar3 from "assets/img/avatars/avatar3.png";
import NFt3 from "assets/img/nfts/Nft3.png";
function Advertisement() {
  return (
    <>
    <div>
          <AdvertisementCard
            // bidders={[avatar1, avatar2, avatar3]}
            // title="MEARN"
            // // author="Esthera Jackson"
            // price="0.91"
            image={NFt3}
          />
    </div>
    </>
    
  )
}

export default Advertisement